export enum AccessRight {
  ISView = "isView",
  ISEDIT = "isEdit",
}